<template>
	<div v-if="show">
		<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif">
			<div style="background-color: #eeeeee; width: 600px">
				<div class="dialog-header" style="min-width: 300px">
					<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">
						{{ $t("new-school") }}
					</span>
					<div style="margin-left: auto; margin-right: 0">
						<md-button @click="handleClear" class="md-icon-button" style="margin-right: -5px">
							<md-icon style="color: white">close</md-icon>
						</md-button>
					</div>
				</div>
				<div class="dialog-body">
					<div style="width: 80%; margin-left: auto; margin-right: auto">
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("school-code") }}</strong>
							</div>
							<div class="value">
								<el-input
									v-model="school_code"
									:class="{ error: error.indexOf('school-code') > -1 }"
									:minlenngth="10"
									:maxlength="10"
									@input="checkSchoolCode"
									:placeholder="$t('school-code')"
								/>
								<span style="color: red" v-if="error.indexOf('school-code') > -1">
									{{ $t("school-code-error") }}
								</span>
							</div>
						</div>
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("username") }}</strong>
							</div>
							<div class="value">
								<el-input
									v-model="username"
									@input="
										val => {
											if (val.length >= 3) {
												error.splice('username')
											}
											if (val.length < 3) {
												error.push('username')
											}
										}
									"
									:minlength="3"
									:placeholder="$t('username')"
									:class="{ error: error.indexOf('username') > -1 }"
								/>
								<span style="color: red" v-if="error.indexOf('username') > -1">
									{{ $t("username-error") }}
								</span>
							</div>
						</div>
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("email") }}</strong>
							</div>
							<div class="value">
								<el-input
									v-model="email"
									@input="error.splice('email')"
									:placeholder="$t('email')"
									:class="{ error: error.indexOf('email') > -1 }"
								/>
								<span style="color: red" v-if="error.indexOf('email') > -1">
									{{ $t("email-required") }}
								</span>
							</div>
						</div>
						<div class="data-item">
							<div class="label">
								<strong>{{ $t("password") }}</strong>
							</div>
							<div class="value">
								<el-input
									v-model="password"
									show-password
									@input="error.splice('password')"
									:class="{ error: error.indexOf('password') > -1 }"
									:placeholder="$t('password')"
								>
									<i
										v-if="validPassword"
										style="color: #81c784"
										class="el-icon-check el-input__icon"
										slot="suffix"
									>
									</i>
								</el-input>
								<span style="color: red" v-if="error.indexOf('password') > -1">{{
									$t("password-error")
								}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="dialog-footer" style="width: 100%; background-color: white">
					<div style="margin-left: auto; margin-right: 0">
						<md-button class="cancel" @click="handleClear">{{ $t("cancel") }}</md-button>
						<md-button class="add" @click="handleAdd">
							<i class="el-icon-loading" v-if="loading" />
							<span>{{ $t("add") }}</span>
						</md-button>
					</div>
				</div>
			</div>
		</md-dialog>
	</div>
</template>
<script>
import axios from "axios"

export default {
	name: "schools-add",
	props: ["show"],
	data() {
		return {
			school_code: "",
			username: "",
			email: "",
			password: "",
			error: [],
			loading: false
		}
	},
	computed: {
		validPassword: function () {
			if (!this.password) return
			var res = this.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/g)
			return res ? true : false
		}
	},
	methods: {
		checkSchoolCode(val) {
			this.school_code = val.toUpperCase()
			if (val.length === 10) this.error.splice("school-code")
			if (!this.school_code || val.length < 10) this.error.push("school-code")
		},
		handleClear: function () {
			this.error = []
			this.username = ""
			this.email = ""
			this.password = ""
			this.school_code = ""
			this.$emit("close")
		},
		handleAdd: function () {
			this.error = []
			if (this.school_code === "" || this.school_code.length < 10) this.error.push("school-code")
			if (this.username === "" || this.username.length < 3) this.error.push("username")
			if (this.email === "") this.error.push("email")
			if (!this.validPassword) this.error.push("password")

			if (this.error.length > 0) return
			var payload = {
				username: this.username,
				email: this.email,
				password: this.password,
				language: localStorage.getItem("lang"),
				school_code: this.school_code.toUpperCase()
			}
			axios
				.post(process.env.VUE_APP_API_URL + "/api/user/createUserNewOrganizationBySuperAdmin", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					this.$notification("success", this.$t("save-successful"), "", 4000)
					this.$emit("add", res.data.school)
				})
				.catch(err => {
					this.$processError(this.$t("save-error"), err.response.data.Message)
					console.error(err)
				})
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-form";

.error {
	border: 1px solid red;
}
</style>
